import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/event_workflow_types/{?id}')
@doc.timestampable
abstract class AbstractEventWorkflowTypeModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'reference': Website_EventWorkflowTypeReference;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		reference: string;
		label: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare reference: Website_EventWorkflowTypeReference;
	@doc.string declare label: string;
}

interface AbstractEventWorkflowTypeModel extends Timestampable {}

export default AbstractEventWorkflowTypeModel;
